<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00079" title="[91]"><a id="Page_91"></a></span></p>
<h2 id="MOVED_JUST_IN_TIME">MOVED JUST IN TIME.</h2>
</div>
<div class="blockquot">
<p class="calibre3">REMOVED FROM ANDERSONVILLE TO THE MARINE HOSPITAL, SAVANNAH—GETTING
THROUGH THE GATE—BATTESE HAS SAVED US—VERY
SICK BUT BY NO MEANS DEAD YET—BETTER AND HUMANE
TREATMENT.</p>
</div>
<p class="calibre3">Aug. 1.—Just about the same. My Indian friend says: “We all
get away.”</p>
<p class="calibre3">Aug. 2.—Two hundred and twenty die each day. No more news
of exchange.</p>
<p class="calibre3">Aug. 3.—Had some good soup, and feel better. All is done for
me that can be done by my friends. Rowe and Sanders in almost
as bad a condition as myself. Just about where I was two or three
weeks ago. Seem to have come down all at once. August goes
for them.</p>
<p class="calibre3">Aug. 4.—Storm threatened. Will cool the atmosphere. Hard
work to write.</p>
<p class="calibre3">Aug. 5.—Severe storm. Could die in two hours if I wanted to,
but don’t.</p>
<p class="calibre3">Aug. 12.—Warm. Warm. Warm. If I only had some shade
to lay in, and a glass of lemonade.</p>
<p class="calibre3">Aug. 13.—A nice spring of cold water has broken out in camp,
enough to furnish nearly all here with drinking water. God has
not forgotten us. Battese brings it to me to drink.</p>
<p class="calibre3">Aug. 14.—Battese very hopeful, as exchange rumors are afloat.
Talks more about it than ever before.</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00080" title="[92]"><a id="Page_92"></a></span></p>
<p class="calibre3">Aug. 15.—The water is a God-send. Sanders better and Rowe
worse.</p>
<p class="calibre3">Aug. 16.—Still in the land of the living. Capt. Wirtz is sick and
a Lieut. Davis acting in his stead.</p>
<p class="calibre3">Aug. 17.—Hanging on yet. A good many more than two hundred
and twenty-five die now in twenty-four hours. Messes that
have stopped near us are all dead.</p>
<p class="calibre3">Aug. 18.—Exchange rumors.</p>
<p class="calibre3">Aug. 19.—Am still hoping for relief. Water is bracing some up,
myself with others. Does not hurt us.</p>
<p class="calibre3">Aug. 20.—Some say three hundred now die each day. No more
new men coming. Reported that Wirtz is dead.</p>
<p class="calibre3">Aug. 21.—Sleep nearly all the time except when too hot to do so.</p>
<p class="calibre3">Aug. 22—Exchange rumors.</p>
<p class="calibre3">Aug. 23.—Terribly hot.</p>
<p class="calibre3">Aug. 24.—Had some soup. Not particularly worse, but Rowe
is, and Sanders also.</p>
<p class="calibre3">Aug. 25.—In my exuberance of joy must write a few lines.
Received a letter from my brother, George W. Ransom, from Hilton
Head.<a class="fnanchor pginternal" href="#/Text/Section0011#Footnote_1" id="FNanchor_1">[A]</a> Contained only a few words.</p>
<div class="footnote">
<p class="calibre3"><a class="label pginternal" href="#/Text/Section0011#FNanchor_1" id="Footnote_1">[A]</a> My brother supposed me dead, as I had been so reported; still,
thinking it might not be so, every week or so he would write a letter
and direct to me as a prisoner of war. This letter, very strangely,
reached its destination.</p>
</div>
<p class="calibre3">Aug. 26.—Still am writing. The letter from my brother has
done good and cheered me up. Eye sight very poor and writing
tires me. Battese sticks by; such disinterested friendship is rare.
Prison at its worst.</p>
<p class="calibre3">Aug. 27.—Have now written nearly through three large books,
and still at it. The diary am confident will reach my people if I
don’t. There are many here who are interested and will see that it
goes north.</p>
<p class="calibre3">Aug. 28.—No news and no worse; set up part of the time. Dying
off a third faster than ever before.</p>
<p class="calibre3">Aug. 29.—Exchange rumors afloat. Any kind of a change
would help me.</p>
<p class="calibre3">Aug. 30.—Am in no pain whatever, and no worse.</p>
<p class="calibre3">Aug. 31.—Still waiting for something to turn up. My Indian
friend says: “good news yet.” <span class="smcap">Night.</span>—The camp is full of exchange
rumors.</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00081" title="[93]"><a id="Page_93"></a></span></p>
<p class="calibre3">Sept 1.—Sanders taken outside to butcher cattle. Is sick but
goes all the same. Mike sick and no longer a policeman. Still
rumors of exchange.</p>
<p class="calibre3">Sept. 2.—Just about the same; rumors afloat does me good. Am
the most hopeful chap on record.</p>
<p class="calibre3">Sept. 3.—Trade off my rations for some little luxury and manage
to get up quite a soup. <span class="smcap">Later.</span>—Sanders sent in to us a quite
large piece of fresh beef and a little salt; another God-send.</p>
<p class="calibre3">Sept. 4.—Anything good to eat lifts me right up, and the beef
soup has done it.</p>
<p class="calibre3">Sept. 4.—The beef critter is a noble animal. Very decided exchange
rumors.</p>
<p class="calibre3">Sept. 5.—The nice spring of cold water still flows and furnishes
drinking water for all; police guard it night and day so to be taken
away only in small quantities. Three hundred said to be dying off
each day.</p>
<p class="calibre3">Sept. 6.—Hurrah! Hurrah!! Hurrah!!! Can’t holler except on
paper. Good news. Seven detachments ordered to be ready to
go at a moment’s notice. <span class="smcap">Later.</span>—<em>All who cannot walk must stay
behind.</em> If left behind shall die in twenty-four hours. Battese
says <em>I shall go</em>. <span class="smcap">Later.</span>—Seven detachments are going out of the
gate; all the sick are left behind. Ours is the tenth detachment
and will go to-morrow so said. The greatest excitement; men
wild with joy. Am worried fearful that I cannot go, but Battese
says I shall.</p>
<p class="calibre3">Sept. 7.—Anxiously waiting the expected summons. Rebels say
as soon as transportation comes, and so a car whistle is music to
our ears. Hope is a good medicine and am sitting up and have
been trying to stand up but can’t do it; legs too crooked and with
every attempt get faint. Men laugh at the idea of my going, as
the rebels are very particular not to let any sick go, still Battese
say I am going. <span class="smcap">Most Dark.</span>—Rebels say we go during the night
when transportation comes. Battese grinned when this news come
and can’t get his face straightened out again.</p>
<p class="calibre3"><span class="smcap">Marine Hospital</span>, Savannah, Ga., Sept. 15, 1864.—A great
change has taken place since I last wrote in my diary. Am in
heaven now compared with the past. At about midnight, September
7th, our detachment was ordered outside at Andersonville, and
Battese picked me up and carried me to the gate. The men were
being let outside in ranks of four, and counted as they went out.
They were very strict about letting none go but the well ones, or<span class="x-ebookmaker-pageno" title="[94]"><a id="Page_94"></a></span>
those who could walk. The rebel adjutant stood upon a box by
the gate, watching very close. Pitch pine knots were burning in
the near vicinity to give light. As it came our turn to go Battese
got me in the middle of the rank, stood me up as well as I could
stand, and with himself on one side and Sergt. Rowe on the other
began pushing our way through the gate. Could not help myself
a particle, and was so faint that I hardly knew what was going on.
As we were going through the gate the adjutant yells out: “Here,
here! hold on there, that man can’t go, hold on there!” and Battese
crowding right along outside. The adjutant struck over the heads
of the men and tried to stop us, but my noble Indian friend kept
straight ahead, hallooing: “He all right, he well, he go!” And so
I got outside, and adjutant having too much to look after to follow
me. After we were outside, I was carried to the railroad in the
same coverlid which I fooled the rebel out of when captured, and
which I presume has saved my life a dozen times. We were crowded
very thick into box cars. I was nearly dead, and hardly knew
where we were or what was going on. We were two days in getting
to Savannah. Arrived early in the morning. The railroads
here run in the middle of very wide, handsome streets. We were
unloaded, I should judge, near the middle of the city. The men
as they were unloaded, fell into line and were marched away.
Battese got me out of the car, and laid me on the pavement. They
then obliged him to go with the rest, leaving me; would not let
him take me. I lay there until noon with four or five others, without
any guard. Three or four times negro servants came to us
from houses near by, and gave us water, milk and food. With
much difficulty I could set up, but was completely helpless. A
little after noon a wagon came and <em>toted</em> us to a temporary hospital
in the outskirts of the city, and near a prison pen they had just
built for the well ones. Where I was taken it was merely an open
piece of ground, having wall tents erected and a line of guards
around it. I was put into a tent and lay on the coverlid. That
night some gruel was given to me, and a nurse whom I had seen in
Andersonville looked in, and my name was taken. The next morning,
September 10th, I woke up and went to move my hands, and
could not do it; could not move either limb so much as an inch.
Could move my head with difficulty. Seemed to be paralyzed, but
in no pain whatever. After a few hours a physician came to my
tent, examined and gave me medicine, also left medicine, and one
of the nurses fed me some soup or gruel. By night I could move<span class="x-ebookmaker-pageno" id="pgepubid00082" title="[95]"><a id="Page_95"></a></span>
my hands. Lay awake considerable through the night thinking.
Was happy as a clam in high tide. Seemed so nice to be under a
nice clean tent, and there was such cool pure air. The surroundings
were so much better that I thought now would be a good time
to die, and I didn’t care one way or the other. Next morning the
doctor came, and with him Sergt. Winn. Sergt. Winn I had had a
little acquaintance with at Andersonville. Doctor said I was terribly
reduced, but he thought I would improve. Told them to wash
me. A nurse came and washed me, and Winn brought me a white
cotton shirt, and an old but clean pair of pants; my old clothing,
which was in rags, was taken away. Two or three times during
the day I had gruel of some kind, I don’t know what. Medicine
was given me by the nurses. By night I could move my feet and
legs a little. The cords in my feet and legs were contracted so, of
course, that I couldn’t straighten myself out. Kept thinking to
myself, “am I really away from that place Andersonville?” It
seemed too good to be true. On the morning of the 12th, ambulances
moved all to the Marine Hospital, or rather an orchard in same
yard with Marine Hospital, where thirty or forty nice new tents
have been put up, with bunks about two feet from the ground,
inside. Was put into a tent. By this time could move my arms
considerable. We were given vinegar weakened with water, and
also salt in it. Had medicine. My legs began to get movable
more each day, also my arms, and to-day I am laying on my stomach
and writing in my diary. Mike Hoare is also in this hospital.
One of my tent mates is a man named Land, who is a printer, same
as myself. I hear that Wm. B. Rowe is here also, but haven’t seen
him.</p>
<p class="calibre3">Sept. 16.—How I do sleep; am tired out, and seems to me I can
just sleep till doomsday.</p>
<p class="calibre3">Sept. 17.—Four in each tent. A nurse raises me up, sitting posture,
and there I stay for hours, dozing and talking away. Whiskey
given us in very small quantities, probably half a teaspoonful
in half a glass of something, I don’t know what. Actually makes
me drunk. I am in no pain whatever.</p>
<p class="calibre3">Sept. 18.—Surgeon examined me very thoroughly to-day. Have
some bad sores caused by laying down so much; put something on
them that makes them ache. Sergt. Winn gave me a pair of socks.</p>
<p class="calibre3">Sept. 19.—A priest gave me some alum for my sore mouth. Had
a piece of sweet potato, but couldn’t eat it. Fearfully weak. Soup
is all I can eat, and don’t always stay down.</p>
<p class="calibre3"><span class="x-ebookmaker-pageno" id="pgepubid00083" title="[96]"><a id="Page_96"></a></span></p>
<p class="calibre3">Sept. 20.—Too cool for me. The priest said he would come and
see me often. Good man. My left hand got bruised in some way
and rebel done it up. He is afraid gangrene will get in sore.
Mike Hoare is quite sick.</p>
<p class="calibre3">Sept. 21.—Don’t feel as well as I did some days ago. Can’t eat;
still can use my limbs and arms more.</p>
<p class="calibre3">Sept. 22.—Good many sick brought here. Everybody is kind,
rebels and all. Am now differently sick than at any other time.
Take lots of medicine, eat nothing but gruel. Surgeons are very
attentive. Man died in my tent. Oh, if I was away by myself, I
would get well. Don’t want to see a sick man. That makes me
sick.</p>
<p class="calibre3">Sept. 23.—Shall write any way; have to watch nurses and rebels
or will lose my diary. Vinegar reduced I drink and it is good;
crave after acids and salt. Mouth appears to be actually sorer than
ever before, but whether it is worse or not can’t say. Sergt. Winn
says the Doctor says that I must be very careful if I want to get
well. How in the old Harry can I be careful? They are the ones
that had better be careful and give me the right medicine and food.
Gruel made out of a dish cloth to eat.</p>
<p class="calibre3">Sept 24.—Arrowroot soup or whatever you may call it; don’t
like it; makes me sick. Priest spoke to me. Cross and peevish and
they say that is a sure sign will get well. Ain’t sure but shall be a
Catholic yet. Every little while get out the old diary from under
the blanket and write a sentence. Never was made to be sick—too
uneasy. This will do for to-day.</p>
<div class="calibre illowe10 figure" id="i_sep3">
<img alt="separator; small circular coastal scene" class="calibre6" id="id-5647963449175851432" src="Images/img0013.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0011.vue?bbc92c14